'use client';

import classNames from 'classnames';

import WithSwiperButton from 'app/components/common/WithSwiperButton';
import { IconArrow } from 'app/components/sprites';
import { ISwiperButtonProps } from 'app/interfaces/ui';
import { sliderButtonThemes } from 'app/utility/themes';

export default function SwiperButtonNext({
  className = 'w-13 h-13 rounded',
  iconClassName = 'w-[15px] h-[26px]',
  theme = sliderButtonThemes.sand
}: ISwiperButtonProps) {
  const {
    bgColor,
    bgColorHover,
    borderColor,
    borderColorHover,
    iconColor,
    iconColorHover
  } = theme;

  return (
    <WithSwiperButton>
      {({ slideNext, isEnd }) => (
        <button
          type="button"
          className={classNames(
            'group button border transition-[opacity,colors] duration-300 cursor-pointer disabled:pointer-events-none disabled:cursor-auto',
            className,
            bgColor,
            bgColorHover,
            borderColor,
            borderColorHover,
            {
              'opacity-60': isEnd
            }
          )}
          disabled={isEnd}
          onClick={slideNext}
        >
          <IconArrow
            className={classNames(
              'fill-none group-hover:translate-x-px transiton-[transform,colors] duration-300',
              iconClassName,
              iconColor,
              iconColorHover
            )}
          />
        </button>
      )}
    </WithSwiperButton>
  );
}
